module.exports = __webpack_public_path__ + "close-white.png?a00318509fcc063faa34a555b5da5346";